"use client";

import React from "react";

//Style
import * as S from "./styles";

//Type
import { TitleStrongTableProps } from "@/types";

const TitleStongTable: React.FC<TitleStrongTableProps> = ({
  className,
  title,
  onClick,
  size,
}) => {
  return (
    <S.TitleStrong className={className} onClick={onClick} size={size}>
      {title}
    </S.TitleStrong>
  );
};

export default TitleStongTable;
